<template>
  <div>
    <div
      class="prompt-container"
      v-if="types"
      @touchmove.prevent
    >
      <div class="prompt"></div>
      <div
        class="fix-content "
        v-if="types==='send-pay-prompt'"
      >
        <div class="header">
          确认支付
          <i
            class="icon"
            @click="cancelPrompt"
          />
        </div>
        <div class="content">
          <p class="price">
            <i class="symbol">￥</i>
            {{ orderDeatil.reSkuId ? orderDeatil.reDealPrice : orderDeatil.dealPrice }}
          </p>
          <pay-method
            :types="'second'"
          />
        </div>
        <div class="btn-row">
          <v-button @click="pay">
            立即付款
          </v-button>
        </div>
      </div>
      <div
        class="order-action-content"
        v-else
      >
        <img
          src="../assets/image/no-record.png"
          class="img"
        />
        <p class="txt">
          {{ txt }}
        </p>
        <div class="btn-row">
          <button
            class="btn cancel"
            @click="cancelPrompt"
          >
            取消
          </button>
          <button
            class="btn confirm"
            @click="confirm"
          >
            确定
          </button>
        </div>
      </div>
    </div>
    <!--微信弹窗-->
    <wx-modal
      v-if="wechatPay.showModal"
      :wx-pay-info="wechatPay"
    />
  </div>
</template>

<script>
  import {mapState, mapGetters} from 'vuex'
  import {PayHelpers} from '../utils/payHelper'
  import payMethod from '@/components/payMethod'
  import vButton from '@/components/Button'
  import wxModal from '../components/WeChatModal'
  import {setStorageCache, isIOS, getSessionCache} from '../utils/'

  export default {
    name: 'orderAction',
    props: {
      types: {
        type: String,
        default: ''
      }
      , orderDeatil: {
        type: Object,
        default() {
          return {}
        }
      }
    },
    computed: {
      ...mapGetters({
        client: 'client' // 客户端信息
      })
      , ...mapState({
        payEnv: state => state.product.payEnv // App应用环境
      })
      , txt() {
        if (this.types === 'del') {
          return '是否删除订单？'
        } else if (this.types === 'cancel') {
          return '是否取消订单?'
        } else {
          return ''
        }
      }
    },
    data() {
      return {
        // 自有微信支付轮询信息
        wechatPay: {
          payUrl: '',
          orderId: '',
          toggleWxApp: true,
          showModal: false
        }
      }
    },
    mounted() {
      if (isIOS() && this.client.env != 'app') { // 只有在微信H5上才有，为了给H5微信支付跳转后界面刷新使用后还能轮训支付结果
        let wxPayInfo = getSessionCache('wxPayInfo')
        let wxPayInfoTime = getSessionCache('wxPayInfoTime')
        let time = new Date().getTime()
        if (wxPayInfo && wxPayInfoTime && (time - wxPayInfoTime) < 120000) {
          this.wechatPay = Object.assign({}, wxPayInfo, {
            toggleWxApp: false
          })
        }
      }
    },
    methods: {
      pay() {
        this.cancelPrompt()
        this.$spinner.open('提交订单...')
        let {productName, skuName, orderNo} = this.orderDeatil
        this.$analysis.trackEvent('【二次支付按钮】', 'material_pay_again_click', `${productName}${skuName}`)
        this.$store.dispatch('secondPay', {
          orderNo: orderNo
        })
          .then(data => {
            this.$spinner.close()
            let {datas} = data
            let {orderItems} = datas
            setStorageCache('productInfo', Object.assign({}, datas, orderItems[0], {
              createTime: datas.orderCreateTime,
              salePrice: datas.saleAmount,
              dealPrice: datas.payAmount,
              proPrice: datas.saleAmount,
              target: datas.orderTarget,
              extValue: '',
              contactName: '',
              contactPhone: '',
              contactAddress: '',
              attrValues: '',
              businessType: '1'
            }))
            setStorageCache('senPay', 'true')
            // 缓存订单信息
            if (data.datas.payStr === 'useless') { // 0元支付
              this.$router.push({name: 'result', params: {state: 'success'}})
              return false
            }
            if (this.client.env === 'wxMini') {
              this.$store.dispatch('wxMiniPay', datas)
            } else {
              PayHelpers[this.payEnv](data, this)
            }
          })
          .catch(() => {
            this.$spinner.close()
            this.$toast('支付失败，请重试')
          })
      },
      cancelPrompt() {
        this.$emit('cancel', {type: '', index: ''})
      },
      confirm() {
        let type = this.types
        if (type === 'del') {
          this.delOrder()
        } else if (type === 'cancel') {
          this.cancelOrder()
        }
      },
      // 删除订单
      delOrder() {
        let {orderNo} = this.orderDeatil
        if (orderNo) {
          this.cancelPrompt()
          this.$spinner.open('正在删除订单...')
          this.$store.dispatch('removeOrder', {
            orderNo
          })
            .then(() => {
              this.$spinner.close()
              this.$emit('confirmDelOrder')
            })
            .catch(() => {
              this.$spinner.close()
              this.$toast('删除失败，请稍候重试')
            })
        }
      },
      // 取消订单
      cancelOrder() {
        let {orderNo} = this.orderDeatil
        if (orderNo) {
          this.cancelPrompt()
          this.$spinner.open('正在取消订单...')
          this.$store.dispatch('closeOrder', {
            orderNo
          })
            .then(() => {
              this.$spinner.close()
              this.$emit('confirmCancelOrder')
            })
            .catch(() => {
              this.$spinner.close()
              this.$toast('取消订单失败，请稍候重试')
            })
        }
      }
    },
    components: {
      vButton
      , payMethod
      , wxModal
    }
  }
</script>
<style scoped lang="scss">
  @import "../assets/common.scss";

  .order-action-content {
    position: fixed;
    background-color: #fff;
    text-align: center;
    width: 814px;
    left: 50%;
    top: 50%;
    border-radius: 24px;
    transform: translate(-50%, -50%);
    z-index: 101;
    font-size: 42px;
    color: #000000;
    .img {
      width: 168px;
      height: 207px;
      margin: 78px 0 25px;
    }
    .txt {
      padding-bottom: 100px;
    }
    .btn-row {
      border-top: solid 1PX #f1f1f1; /* no */
      @extend %flex-center-center;
      .btn {
        color: #888888;
        width: 50%;
        height: 145px;
        border-right: solid 1PX #f1f1f1; /* no */
        background-color: #fff;
        font-size: 42px;
        &.cancel {
          border-bottom-left-radius: 42px;
          color: #888888;
        }
        &.confirm {
          border: none;
          border-bottom-right-radius: 42px;
        }
      }
    }
  }

  .fix-content {
    @extend %fix-content;
    z-index: 101;
    background-color: #f1f1f1;
    .header {
      background-color: #fff;
      font-size: 48px;
      color: #000000;
      position: relative;
      line-height: 120px;
      .icon {
        background: url("../assets/image/close2.png") no-repeat center left;
        background-size: 39px 39px;
        width: 89px;
        height: 120px;
        display: block;
        position: absolute;
        top: 0px;
        right: 0px;
      }
    }
    .content {
      @extend %content;
      margin-bottom: 20px;
      padding: 0 14px 0 9px;
      .price {
        color: #ff1314;
        font-size: 90px;
        line-height: 170px;
        /*border-bottom: solid 1PX #f1f1f1; !*no*!*/
        margin: 0 27px 0 30px;
        .symbol {
          font-size: 48px;
        }
      }
    }
    .btn-row {
      padding: 20px 0 19px;
      background-color: #fff;
    }
  }
</style>
